import React, { CSSProperties } from 'react'

interface DownarrowProps {
    style?: CSSProperties
    className?: string
}

const Downarrow: React.FC<DownarrowProps> = ({
    className,
    style,
    ...props
}) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='17'
            style={style}
            className={className}
            fill='none'
            viewBox='0 0 16 17'
            {...props}
        >
            <path
                stroke='#23252A'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='1.333'
                d='m4 6.5 4 4 4-4'
            ></path>
        </svg>
    )
}

export default Downarrow
